import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  routePaths,
  routePathReplacingParams,
} from 'js/components/router/route-paths';

const LawyerRedirect = (props) => {
  const {
    match: {
      params: { lawyerId },
    },
    location: { search = '' },
  } = props;
  const path = routePathReplacingParams(routePaths.lawyerInformation, {
    lawyerId,
  });
  return <Redirect to={`${path}${search}`} />;
};

export default LawyerRedirect;
